/**
 * Every periodic update of the player's page happens in one animation frame:
 * each frame in which the page changes costs a weak GPU video frames while
 * two or more videos play (spike 0.1a, Android tablet).
 *
 * @module
 */
import { createContext } from "react";

export type FrameDraw = (now: number, dt: number) => void;

export class UiFrames {
  private readonly draws = new Set<FrameDraw>();

  add(draw: FrameDraw): () => void {
    this.draws.add(draw);
    return () => this.draws.delete(draw);
  }

  run(now: number, dt: number): void {
    for (const d of this.draws) d(now, dt);
  }
}

export const UiFramesContext = createContext<UiFrames | null>(null);

/**
 * Update intervals (ms), fastest first. The grid steps down them while
 * videos drop frames, before it pauses any slot.
 */
export const UI_INTERVALS_MS = [100, 250, 500] as const;
